// StepTwo.js
import React from "react";

function StepTwo({ 
  formData, 
  formErrors, 
  touched, 
  handleChange, 
  handleBlur, 
  showPassword, 
  showConfirmPassword, 
  togglePasswordVisibility, 
  toggleConfirmPasswordVisibility, 
  setStep, 
  validUserError // <-- Add this prop to receive validUserError
}) {
  return (
    <>
      <div className="form-group-unique">
        <label htmlFor="email">Email</label>
        <input
          type="text"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.email && (formErrors.email || validUserError) && (
          <p className="error">{formErrors.email || validUserError}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="phoneNumber">Mobile Number</label>
        <input
          type="text"
          id="phoneNumber"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.phoneNumber && formErrors.phoneNumber && (
          <p className="error">{formErrors.phoneNumber}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="password">Password</label>
        <div className="password-input-unique">
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <span className="toggle-password-unique" onClick={togglePasswordVisibility}>
            <img
              src={showPassword ? "/eye.svg" : "/eye-slash.svg"}
              alt="toggle visibility"
            />
          </span>
        </div>
        {touched.password && formErrors.password && (
          <p className="error">{formErrors.password}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="passwordConfirm">Confirm Password</label>
        <div className="password-input-unique">
          <input
            type={showConfirmPassword ? "text" : "password"}
            id="passwordConfirm"
            name="passwordConfirm"
            value={formData.passwordConfirm}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <span
            className="toggle-password-unique"
            onClick={toggleConfirmPasswordVisibility}
          >
            <img
              src={showConfirmPassword ? "/eye.svg" : "/eye-slash.svg"}
              alt="toggle visibility"
            />
          </span>
        </div>
        {touched.passwordConfirm && formErrors.passwordConfirm && (
          <p className="error">{formErrors.passwordConfirm}</p>
        )}
      </div>

      <div className="form-group-unique">
        <button
          type="button"
          onClick={() => setStep(1)}
          className="btn-back-unique"
        >
          Back
        </button>
      </div>
    </>
  );
}

export default StepTwo;